import { queryOptions } from '@tanstack/react-query'
import { apiGet } from './client'

/**
 * "My new Performance" (LTP) - `easeedesk-dashboards/My_new_performance`.
 *
 * E al treilea ecran din portal care poarta numele "performance", si singurul
 * cu PUNCTE. Nu se ajunge la el din meniu: butonul "My LTP" din All Reports
 * duce acolo. Sta la `/app/easeedesk/my_new_performance`.
 */

export interface NewPerformancePage {
  /** Fals cand furnizorul n-are scara de puncte - vezi `PointScheme` in API. */
  ready: boolean
  title: string
  sp: number
  /**
   * Ora de la care incepe ziua la furnizorul asta: 12 la 20266, 0 la restul.
   * Scriptul vechi o alegea din variabila `sp` scrisa de antetul portalului.
   */
  day_start_hour: number
}

export interface LivePoints {
  /** "Live Tickets Points": punctele adunate, minus cele patru pedepse. */
  ltp: number
  connectedtickets: number
  over20minInConnected: number
  over20minInRemoteControl: number
  over10minInProgress: number
  latetotookover: number
}

/** O bara din "Top Ticket Types": cate tichete rezolvate are omul pe un tip. */
export interface TypeCount {
  count: number
  type_name: string
  color_identifier: string
}

export interface NewPerformanceData {
  ready: boolean
  service_provider: { sp: number }
  live_points: LivePoints
  resolved_points: {
    /** "Ticket Points": punctele tichetelor rezolvate, minus pedepsele. */
    ltp_resolved: number
    /** "Reopen": cate redeschideri a prins omul in perioada. */
    rework: number
  }
  topresolved: TypeCount[]
  /**
   * Panoul "Activity". Se uita la ZIUA DE LUCRU, nu la perioada aleasa: la
   * furnizorul 20266 ziua tine de la 12 la 12.
   */
  admin: {
    /** `null` cand omul n-a intrat azi - portalul scria "Not Available". */
    login: string | null
    logout: string | null
    inactiveMinutes: number
    workingSeconds: number
    pauseSeconds: number
  }
  /** "Category Tickets Number": cele trei sertare de dificultate. */
  category_tickets: { extended: number; advanced: number; basics: number }
  /**
   * Panourile "My Position In Team": clasamentul echipei pe puncte, decupat
   * in jurul omului - doi inaintea lui, el, doi dupa. Lista goala inseamna
   * ca nu apare in clasament; portalul scria acolo "Not available".
   */
  standings: { live: StandingRow[]; resolved: StandingRow[] }
  /**
   * Cele patru cifre pe care ecranul le imparte cu "My Performance", si
   * SINGURELE din partea aia pe care macheta chiar le arata - restul se
   * calculau in portal si se aruncau, fiindca elementele lor sunt comentate
   * sau nu sunt incarcate deloc.
   */
  active: number
  closed: number
  top: StatusCount[]
  active_daily: DailyPoint[]
}

/** O bara din "Top Ticket Status": cate tichete vii sunt intr-o stare. */
export interface StatusCount {
  count: number
  status_name: string
  status_color: string
}

/** Un punct din graficul "Tickets / hours". */
export interface DailyPoint {
  active: number
  progress: number
  resolved: number
  /** Ora din care s-au deschis tichetele, "HH:mm". */
  created: string
}

export interface StandingRow {
  position: number
  name: string
  pct: number
  me: boolean
}

export const newPerformancePageQuery = queryOptions({
  queryKey: ['easeedesk', 'my-new-performance', 'page'],
  queryFn: () => apiGet<NewPerformancePage>('/easeedesk/my-new-performance'),
})

export function newPerformanceDataQuery(from: string, to: string) {
  /*
   * `all_tickets=false` mereu: bifa e comentata in macheta veche, iar scriptul
   * o intreaba pe un element care nu exista, deci trimitea mereu "false".
   * Perioada e singurul filtru al ecranului.
   */
  const p = new URLSearchParams({ all_tickets: 'false', start: from, end: to })

  return queryOptions({
    queryKey: ['easeedesk', 'my-new-performance', 'data', p.toString()],
    queryFn: () => apiGet<NewPerformanceData>(`/easeedesk/my-new-performance/dashboard-data?${p.toString()}`),
  })
}
